export const api = {
  GET_SHUMA_STEPS_STATUS: '/steps/getShumaStepsStatus',
  GET_SHUMA_PROPERTIES: '/steps/getShumaProperties',
  GET_STEP_DATA: '/steps/getStepData',
  SUBMIT_STEP_BY_STEP_ID: step => `/steps/submitStep${step}`,
  GET_NESACH_TABU: '/steps/getNesachTabu',

  UPLOAD_FILE: '/file/upload/upload_file',
  EDIT_FILE: '/file/upload/edit_file',
  EDIT_ORDER_FILE: '/file/upload/edit_order_file',
  GET_FILE_LIST: '/files/getFileList',
  GET_FILE: '/files/getFile',
  DELETE_FILE: '/files/deleteFile',
  DELETE_ORDER_FILE: '/files/deleteOrderFile',

  GET_CITIES: '/generaldata/getCities',
  GET_CITIES_GENERAL_ASSETS: '/generaldata/getCitiesListForGeneralAssets',
  GET_STREETS: '/generaldata/getStreets',
  GET_STREETS_GENERAL_ASSETS: '/generaldata/getStreetsListForGeneralAssets',

  GET_STEP_9_TAX_AUTHORITY: 'steps/getStep9TabTaxAuthority',
  GET_STEP_9_TAX_AUTHORITY_FOR_EXCEL: 'steps/getStep9TabTaxAuthorityForExcel',
  GET_STEP_9_GIRD_FIRM_DATA: '/steps/getStep9GridFirm',
  GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL: '/steps/getAllStep9GridFirm',
  GET_STEP_9_GIRD_SHARED_DATA: '/steps/getStep9GridShared',
  GET_STEP_9_GRID_SHARED_DATA_FOR_EXCEL: '/steps/getAllStep9GridShared',

  GET_SAVED_ROWS_TAX_AUTHORITY: '/step9/getStep9SavedRowsTaxAuthorityList',
  GET_SAVED_ROWS_FIRM: '/step9/getStep9SavedRowsFirmList',
  GET_SAVED_ROWS_SHARED: '/step9/getStep9SavedRowsSharedList',
  GET_SAVED_ROWS_SURVEY_ASSETS: 'step9/getStep9SavedRowsSurveyAssetsList',

  GET_SAVED_ROWS_FOR_EXCEL_TAX_AUTHORITY: '/step9/getStep9SavedRowsTaxAuthorityListForExcel',
  GET_SAVED_ROWS_FOR_EXCEL_FIRM: '/step9/getStep9SavedRowsFirmListForExcel',
  GET_SAVED_ROWS_FOR_EXCEL_SHARED: '/step9/getStep9SavedRowsSharedListForExcel',
  GET_SAVED_ROWS_FOR_EXCEL_SURVEY_ASSETS: '/step9/getStep9SavedRowsSurveyAssetsListForExcel',

  SAVE_ROW_TAX_AUTHORITY: '/step9/step9CreateSavedRowTaxAuthority',
  SAVE_ROW_FIRM: '/step9/step9CreateSavedRowFirm',
  SAVE_ROW_SHARED: '/step9/step9CreateSavedRowShared',
  SAVE_ROW_SURVEY_ASSETS: '/step9/step9CreateSavedRowSurveyAssets',

  REMOVE_ROW_TAX_AUTHORITY: '/step9/step9DeleteSavedRowTaxAuthority',
  REMOVE_ROW_FIRM: '/step9/step9DeleteSavedRowFirm',
  REMOVE_ROW_SHARED: '/step9/step9DeleteSavedRowShared',
  REMOVE_ROW_SURVEY_ASSETS: '/step9/step9DeleteSavedRowSurveyAssets',

  GET_ORIGINAL_ROW_TAX_AUTHORITY: '/step9/getStep9OriginTaxAuthorityByID',
  GET_ORIGINAL_ROW_FIRM: '/step9/getStep9OriginFirmByID',
  GET_ORIGINAL_ROW_SHARED: '/step9/getStep9OriginSharedByID',
  GET_ORIGINAL_ROW_SURVEY_ASSETS: '/step9/getStep9OriginSurveyAssetsByID',

  EDIT_ROW_TAX_AUTHORITY: '/step9/step9UpdateSavedRowTaxAuthority',
  EDIT_ROW_FIRM: '/step9/step9UpdateSavedRowFirm',
  EDIT_ROW_SHARED: '/step9/step9UpdateSavedRowShared',
  EDIT_ROW_SURVEY_ASSETS: '/step9/step9UpdateSavedRowSurveyAssets',

  GET_STEP_9_SAVED_ROWS: '/steps/getStep9SavedRows',
  GET_STEP_9_SAVED_COLS: '/steps/getStep9GridsColumnSettings',
  SAVE_STEP_9_COLUMN_DISPLAY: '/steps/step9UpdateColumnDisplay',
  STEP_10_UPDATE_CALC_WEIGHTS: '/steps/step10UpdateCalcWeights',
  UPDATE_FILE_METADATA: '/files/updateFileMetadata',
  EDIT_PDF_PAGES: '/files/editPDFPages',
  EDIT_ORDER_PDF_PAGES: '/files/editOrderPDFPages',
  CREATE_FINAL_PDF: '/steps/createFinalPDF',
  SEND_FOR_ADMIN_APPROVAL: '/steps/sendForAdminApproval',
  SEND_PDF_DRAFT: '/steps/sendPDFDraft',
  FIND_CUSTOMER: '/preSteps/findCustomer',
  ADD_EDIT_CUSTOMER: '/preSteps/addEditCustomer',
  CLOSE_INSPECTION: '/inspections/closeShuma',
};
